<template>
  <div>
    <el-form :model="queryForm"
             :rules="queryFormRules"
             ref="queryFormRef"
             label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="服务平台"
                        prop="platform">
            <el-select v-model="platform"
                      placeholder="请选择要查询的服务平台"
                      @change="getKeyList">
              <el-option  v-for="item in platformList"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="Key"
                        prop="key">
            <el-select v-model="queryForm.key"
                       placeholder="请选择要查询的key"
                       style="width:410px"
                       @change="getApiList">
              <el-option v-for="item in keyOptionList"
                         :key="item.key"
                         :label="item.keyName+'//'+item.key"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接口"
                        prop="api">
            <el-select v-model="queryForm.api"
                       placeholder="请选择要查询接口"
                       style="width:160px">
              <el-option v-for="item in apiList"
                         :key="item.api"
                         :label="item.alias"
                         :value="item.api"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item prop="timeType"
                        label="时间区间">
            <el-radio-group v-model="queryForm.timeType">
              <el-radio :label="1">最近一小时</el-radio>
              <el-radio :label="2">最近一天</el-radio>
              <el-radio :label="3">最近一周</el-radio>
              <el-radio :label="4">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8"
                style="border: 1px solid transparent">
          <el-date-picker style="width:380px"
                          v-model="timeRange"
                          align="center"
                          type="daterange"
                          v-if="queryForm.timeType ===4"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['00:00:00', '23:59:59']"
                          :picker-options="pickerOptions"
                          value-format="timestamp">
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-button style="width:100px"
                     type="primary"
                     @click="queryInfo">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeTable"
             @tab-click="queryInfo"
             type="card">
      <el-tab-pane label="调用量"
                   name="1">
        <div style="display: flex; justify-content: center">
          <div id="doesChart"
               style="width: 750px;height:400px;"></div>
        </div>

      </el-tab-pane>
      <el-tab-pane label="QPS"
                   name="2">
        <div style="display: flex; justify-content: center">
          <div id="qpsChart"
               style="width: 750px;height:400px;"></div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import http from '@/http/index.js'

import * as echarts from 'echarts';
// import { cloneDeep } from 'lodash';
import queryKey from '../mixins/queryKey'
import queryApiList from '../mixins/queryApiList'

export default {
  mixins: [queryKey, queryApiList],
  data() {
    return {
      option: {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          name: '时间'
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          type: 'value',
          name: '用量'
        },
        legend: {
          data: ['用量']
        },
        series: [
          {
            name: '用量',
            data: [],
            type: 'line'
          }
        ]
      },
      pickerOptions: {
        disabledDate(date) {
          const end = new Date( // 当天23:59
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 - 1
          );
          return (
            (date.getTime() >= end.getTime() - 86400000) ||
            (date.getTime() <= end.getTime() - 90 * 86400000)
          );
        }
      },
      queryForm: {
        key: null,
        api: null,
        timeType: 1,
        xType: null,
        start: null,
        end: null,
        type: null
      },
      timeRange: [],
      activeTable: '1',
      queryFormRules: {
        key: [{ required: true, message: '请选择Key', trigger: 'blur' }],
        api: [{ required: true, message: '请选择接口', trigger: 'blur' }],
        timeType: [
          { required: true, message: '请选择查询时间范围', trigger: 'blur' }
        ]
      },
      doseData: null,
      qpsData: null,
      myDoesChart: null,
      myQpsChart: null,
      chartData: null
    };
  },
  mounted() {
    // 初始化echart实例
    this.myDoesChart = echarts.init(document.getElementById('doesChart'));
    this.myQpsChart = echarts.init(document.getElementById('qpsChart'));
  },
  methods: {
    queryInfo() {
      this.$refs.queryFormRef.validate(async (valid) => {
        if (!valid) return;
        this.queryForm.xType = this.queryForm.timeType;
        if (this.queryForm.timeType === 4) {
          // 调用量自定义查询参数添加
          if (this.timeRange === null) {
            this.$message.error('请输入自定义时间范围');
          } else {
            this.queryForm.start = this.timeRange[0] / 1000;
            this.queryForm.end = this.timeRange[1] / 1000;
            let timesDiff = this.queryForm.end - this.queryForm.start;
            let days = timesDiff / (60 * 60 * 24);
            if (days > 1) {
              this.queryForm.xType = 3;
            } else {
              this.queryForm.xType = 2;
            }
          }
        }
        // this.queryForm.key = 'map-test';
        this.queryForm.type = this.activeTable;
        this.flowQuery();
      });
    },
    async flowQuery() {
      const res = await http.flow.detail(this.queryForm);
      this.chartData = res;
      this.formatTime();
      if (this.queryForm.type === '1') {
        this.myDoesChart.setOption(this.option, true);
      } else {
        this.myQpsChart.setOption(this.option, true);
      }
    },
    formatTime() {
      // switch (this.queryForm.xType) {
      this.option.xAxis.data = [];
      this.option.series[0].data = [];
      if (this.option.series.length > 1) {
        this.option.series.pop()
        this.option.legend.data.pop()
      }
      switch (this.queryForm.xType) {
        case 1:
          // 按分钟显示
          this.chartData.forEach((item) => {
            let date = new Date(item.timestamp * 1000);
            this.option.xAxis.data.push(String(date.getMinutes()) + '分');
            this.option.series[0].data.push(item.value);
          });
          break;
        case 2:
          // 按小时展示
          this.chartData.forEach((item) => {
            let date = new Date(item.timestamp * 1000);
            this.option.xAxis.data.push(String(date.getHours()) + '时');
            this.option.series[0].data.push(item.value);
          });
          break;
        case 3:
          // 按天展示
          const limit = {
            name: '限额',
            data: [],
            type: 'line',
            itemStyle: {
              normal: {
                color: 'red',
                lineStyle: {
                  color: 'red'
                }
              }
            }
          }
          this.chartData.forEach((item) => {
            let date = new Date(item.timestamp * 1000);
            this.option.xAxis.data.push(
              String(date.getMonth() + 1) + '.' + String(date.getDate())
            );
            this.option.series[0].data.push(item.value);
            limit.data.push(item.limit)
          });
          this.option.series.push(limit)
          this.option.legend.data.push('限额')
          break;
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .el-tabs__nav-scroll{
  width: 300px;
  margin: 0 auto;
}
</style>
